import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';
import { sbGetGroupChannel } from '~/services/api/coordinate';
import { ICoordinateActions, IThunkRemoveMember } from '../types';

const onRemoveMember: IThunkRemoveMember = thunk(
  async (
    { updateChannel }: Actions<ICoordinateActions>,
    { channelUrl, userIds }: { channelUrl: string; userIds: string[] },
  ) => {
    await api.coordinate.removeMember(channelUrl, userIds);
    const updatedChannel = await sbGetGroupChannel(channelUrl);

    updateChannel(updatedChannel);
  },
);

export default onRemoveMember;
